// extracted by mini-css-extract-plugin
export default {"moduleTitle":"bM_gX","noTag":"bM_gY","viewMore":"bM_dX","search":"bM_2"};